import { useFormik } from "formik";
import { Modal } from "react-bootstrap";
import { URL_LIST_ALL } from "../../configs/api";
import Axios from "axios";
import { useEffect, useState } from "react";
import SerchBoxMulti from "../../component/SerchBoxMulti";

export default function ModalChiaData({ refresh, setRefresh, pipelines, user }) {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [listCustomer, setListCustomer] = useState([]);
    const [type, setType] = useState(1);

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    "Content-Type": "application/json; charset=UTF-8",
                },
            };
            let urlapi = `${URL_LIST_ALL}leads?position=${type}&limit=100000`
            const response = await Axios.get(urlapi, config);
            if (response.data.status === "success") {
                setLoading(false);
                setListCustomer(response.data.data || []);
            }
        } catch (err) {
            console.error("Lỗi lấy danh sách khách hàng:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user?.access_token && showModal) fetchCustomers();
    }, [showModal, type]);

    const formik = useFormik({
        initialValues: { selectedCustomers: [] },
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting,setResetForm }) => {
            setSubmitting(true);
            Axios.post(URL_LIST_ALL + 'assignment', { list_user: values.list_user, list_assign: values.selectedCustomers }, user.config).then(res => {
                setSubmitting(false);
                if (res.data.status == 'success') {
                    alert('Chia thành công')
                    window.location.reaload()
                    setResetForm(true)
                } else {
                    alert('Chia thất bại: ' + res.data.message)
                }
            }).catch(err => console.log(err));
            
        },
    });

    const handleToggleAll = (e) => {
        if (e.target.checked) {
            formik.setFieldValue("selectedCustomers", listCustomer.map(c => c.id));
        } else {
            formik.setFieldValue("selectedCustomers", []);
        }
    };

    const handleToggleOne = (id) => {
        const selected = formik.values.selectedCustomers;
        if (selected.includes(id)) {
            formik.setFieldValue("selectedCustomers", selected.filter(i => i !== id));
        } else {
            formik.setFieldValue("selectedCustomers", [...selected, id]);
        }
    };

    const isAllSelected = listCustomer.length > 0 && formik.values.selectedCustomers.length === listCustomer.length;

    return (
        <>
            <button type="button" className="btn btn-sm btn-danger ml-2" onClick={() => setShowModal(true)}>Assign</button>
            <Modal show={showModal} onHide={() => setShowModal(false)} animation={true} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Assign</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="new-added-form" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <label>Chọn nguồn</label>
                                <select className="form-control height32" onChange={(e) => setType(e.target.value)}>
                                    {pipelines && pipelines.map(item =>
                                        <option value={item.id} key={item.id}>{item.title}</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-12 col-sm-6">
                                <label>Đối tượng nhận (Không nhập tức là chia cho tất cả)</label>
                                <SerchBoxMulti apiname={"users"} alldata="role_id=3" multiple={true} placeholder="Chọn sale" colvalue={'code'} colname={'fullname'} defaultValue={formik.values['list_user']} name='list_user'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('list_user', e)
                                    }}></SerchBoxMulti>
                                <small>Nhập MSNV người nhận được phân tách nhau bởi dấu , (dấu phẩy)</small>
                            </div>

                            {loading ? <div className="loader"></div> : <>

                                <div className="col-12 col-sm-4">
                                    <div className="form-check mb-2">
                                        <input className="form-check-input" type="checkbox" id="checkall" checked={isAllSelected} onChange={handleToggleAll} />
                                        <label className="form-check-label" htmlFor="checkall">
                                            <strong>Chọn tất cả</strong>
                                        </label>
                                    </div>
                                </div>

                                {listCustomer && listCustomer.length > 0 ? listCustomer.map((item) => (
                                    <div className="col-12 col-sm-4 item mt-2" key={item.id}>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={'item_cus_' + item.id}
                                                value={item.id}
                                                checked={formik.values.selectedCustomers.includes(item.id)}
                                                onChange={() => handleToggleOne(item.id)}
                                            />
                                            <label className="form-check-label" htmlFor={'item_cus_' + item.id}>
                                                {item.fullname} | {item.contact}
                                            </label>
                                        </div>
                                    </div>

                                )) : ''}
                            </>}
                            <div className="col-12 mt-3">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success mr-2">
                                    {formik.isSubmitting ? <div className="loader"></div> : "Bắt đầu chia"}
                                </button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}
